
export const JAVA = "java"
export const PYTHON="python"
export const ALL_LANGUAGES=[JAVA, PYTHON]
export const ONE_SEC=1000
export const ONE_MIN=60*ONE_SEC
export const ONE_HOUR=60*ONE_MIN
export const ONE_DAY=24*ONE_HOUR
var WebSocketUrl=""

export function setWebSocketBaseUrl(url){
  if(!url) return
  WebSocketUrl=url
}

/**
 * no security is uses i.e. wss is not used, its not so sensistive data 
 * and wss would add more complexity and slow down things
 * @returns webSocketUrl or  "ws://localhost:9092"
 */
export function getWebSocketBaseUrl(){
  if(WebSocketUrl) return WebSocketUrl
  else return "ws://localhost:9092" 
  //return "http://localhost:9092"
}

/** setting up url for backend, url end with '/'  */
export function homeUrl(){
  //local testing from laptop using frontend server
  // return "http://localhost/"; 
 
 // local testing from mobile connected to same wifi network
 // return "http://192.168.1.2/";
 
   return "/"; // production
}

/** converts string to lowercase
 * handles null and indefined cases as well
 * returns empty string by default
 */
export function toLowerCase(input, defaultValue="") {
    try{
        if (!input || input == null) {
        // Handles both null and undefined
        return defaultValue;
        }
        return String(input).toLowerCase();
    }catch(ex){
        return defaultValue
    }
    
  }

  export function success(status){
    try{
      if(!status || status==null) return false
     if(status==200||status==201) return true;
    } catch(err){}
    return false
}

/** Some error occured please try again */
export function errorMsg(){
    return "Some error occured please try again"
}

export function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

export function dateString(time){
    if(!time) time = Date.now();
    const date = new Date(time);
    const dateString = date.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
    const timeString = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
    const formattedString = `${dateString}, ${timeString}`;
    //console.log(formattedString); // "24 Feb 2024, 5:20 pm"
    return formattedString;
} 

export async function handleCtrlSave(e, callbackSave) {
    if ((window.navigator.platform.match('Mac') ? e.metaKey : e.ctrlKey) && (e.keyCode === 83 || e.key==='s')) {
      e.preventDefault();
     // console.log('Saving...');
     await callbackSave();
    }
  }

  /** returns number value from local storage */
  export function getNumberFromLocalStorage(key, defaultValue=-1) {
    try {
      const value = localStorage.getItem(key);
      // Parse the value as a number and convert it to a long
      const longValue = parseInt(value, 10); // 10 is radix
      // Check if parsing resulted in a NaN (Not a Number)
      if (isNaN(longValue)) {
        return defaultValue;
      }
      return longValue;
    } catch (error) {
      console.log('Error retrieving value from localStorage for key: '+key+", error : "+ error);
      return -1;
    }
  }

  export function getNumber(str, defaultValue=-1){
    try{
      const longValue = parseInt(str, 10); // 10 is radix
      // Check if parsing resulted in a NaN (Not a Number)
      if (isNaN(longValue)) {
        return defaultValue;
      }
      return longValue;
    }catch(exception){
      return defaultValue
    }

  }
  
  export function isBlankOrNullString(str){
    return str==null || !str || str=="" || str.length==0
  }

  export function getYoutubeVideoId(url) {
    if(!url || url.length<=0) return ""
    try{
    const regExp = /(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|\?feature=youtu.be\/))([^#&?]*)/i;
    const match = url.match(regExp);
  
    return match && match[1] ? match[1] : "";
    }catch(exception){
      return ""
    }
  }

  export function isYoutubeVideo(url){
    if(!url) return false
    return url && (url.startsWith("https://www.youtube.com/") 
            || url.startsWith("https://youtu.be/"))
  }

  export function removeNonEnglishWords(text) {
    if(!text) return ""
    return text.split(" ")
        .filter(word => /^[a-zA-Z0-9.,!?'"()]+$/.test(word))  // Keep only English words & common punctuation
        .join(" ");
}